/** ------------- TYPES ACCESSING ENUM VALUES ---------------- */

/* ------ Language and labels ------- */

/** Get enum values */
export type CountryLabel = `${Country}`;
/** Get enum values */
export type LanguageShortLabel = `${LanguageShort}`;
/** Get enum values */
export type LanguageLongLabel = `${LanguageLong}`;
/** Get enum values in corresponding arrays */
export interface LanguageLabels {
    short: Array<LanguageShortLabel>;
    long: Array<LanguageLongLabel>;
}

/* ------ Video and images ------- */

/** Get enum values */
export type VideoHostLabel = `${VideoHost}`;

/* ------ Alignment ------- */

/** Get enum values */
export type AlignmentLabel = `${Alignment}`;

/* ------ Popovers ------- */

export interface PopoverConfig {
    popoverHeight: (() => void) | number;
    verticalOffset: (() => void) | number;
    popoverWidth: (() => void) | number;
    horizontalOffset: (() => void) | number;
    topOffset: (() => void) | number;
    invertHorizontalAlignment: (() => void) | boolean;
    supportMiddleAlignment: (() => void) | boolean;
    supportTopAlignment: (() => void) | boolean;
    supportBottomAlignment: (() => void) | boolean;
    horizontalAxis: (() => void) | boolean;
    horizontalAxisSide: (() => void) | Alignment.Left | Alignment.Right | null;
    verticalAxisSide:
        | (() => void)
        | Alignment.Top
        | Alignment.Middle
        | Alignment.Bottom
        | null;
}

export type PopoverHandler = () => PopoverHandlerResult;

export interface PopoverHandlerResult {
    [Coordinate.X]: string;
    [Coordinate.Y]: string;
    align: string;
    shift: string;
}

/* ------ Slots ------- */
export type UIAnnotationSlotString = `${UIAnnotationSlot}`;

/** ------------- ENUMS ---------------- */

/* ------ Language and labels ------- */

export enum Country {
    Estonia = 'EE',
    Latvia = 'LV',
    Lithuania = 'LT',
}

export enum Locale {
    Estonia = 'et-EE',
    Latvia = 'lv-LV',
    Lithuania = 'lt-LT',
    ISO8601 = 'iso8601',

    // Only for legacy support, do not use in new implementations
    LegacyEN = 'en',
    LegacyRU = 'ru',
    LegacyEE = 'ee',
    LegacyLV = 'lv',
    LegacyLT = 'lt',
}

export enum Language {
    English = 'en',
    Russian = 'ru',
    Estonian = 'et',
    Latvian = 'lv',
    Lithuanian = 'lt',
}

export enum LanguageShort {
    Estonian = 'ET',
    Latvian = 'LV',
    Lithuanian = 'LT',
    English = 'EN',
    Russian = 'RU',
}

export enum LanguageLong {
    Estonian = 'EST',
    Latvian = 'LAT',
    Lithuanian = 'LIT',
    English = 'ENG',
    Russian = 'RUS',
    Empty = '',
}

/* ------ Video and images ------- */

export enum VideoHost {
    YouTube = 'youtube',
    Unknown = 'unknown',
}

/* ------ Alignment ------- */

export enum Alignment {
    Top = 'top',
    Right = 'right',
    Bottom = 'bottom',
    Left = 'left',
    Middle = 'middle',
    None = 'none',
}

export enum Coordinate {
    X = 'x',
    Y = 'y',
    Z = 'z',
}

/* ------ Keyboard ------- */

export enum KeyCode {
    BACKSPACE = 8,
    TAB = 9,
    ENTER = 13,
    ESCAPE = 27,
    SPACE = 32,
    PAGEUP = 33,
    PAGEDOWN = 34,
    HOME = 36,
    END = 35,
    LEFT = 37,
    UP = 38,
    RIGHT = 39,
    DOWN = 40,
    DEL = 46,
}

/* ------ Slots ------- */

export enum UIAnnotationSlot {
    Title = 'title',
    Message = 'message',
    Action = 'action',
}

/* ------ States / Statuses ------- */

export enum ComponentState {
    On = 'on',
    Off = 'off',
    Open = 'open',
    Opened = 'opened',
    Closed = 'closed',
    Rendered = 'rendered',
    Visible = 'visible',
}
